// src/store.js
import { createStore } from "vuex";
import Page from "./models/Page";

export default createStore({
  state: {
    // Estados de interfaz
    showMeetingLeftSideBar: false,
    showNewMeetingWindow: false,
    showRightSideBar: false,
    showAddUserWindow: false,
    showUserProfile: false,
    showKanban: false,
    showBurndownChart: false,
    showTrelloCard: false,
    showMembers: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    snackbarIcon: "",
    messagesWithoutRead: 0,
    messages: [],

    // Modelo de datos
    project: null,
    meetingMinute: null,
    meeting: null,
    elements: null,
    selectedCard: null,
    user: null,
    projectsList: null,
    subprojects: [],
    project_users: null,
    conected_users: [],
    users_map: null,

    // Minuta de reunion
    localStream: null, // Almacena el stream de audio local
    isMuted: true,    // Estado de mute global

    // Sprints
    productBacklog: [],
    sprintBacklog: [],

    // CMS al crear un nuevo proyecto
    cms_view: 1,
    newProject: {
      name: "",
      tabName: "",
      projectDateI: "",
      projectDateT: "",
      typeProject: '',
      description: "",
      options: {
        useChat: true,
        isAgile: false,
        useKanban: true,
        typeProject: 'mixto',
        useVoting: false,
        hasSubprojectsFromCommitment: false,
      },
      iconUrl: "",
      userMembers: [localStorage.getItem('email')],
      userTypes: [],
      taskScore: "",
      pages: [new Page("Pagina de inicio", 0)],
      metrics: {
        elements: 0,
        meetings: 0,
        sprints: 0,
      },
      subprojectName: "comisión",
    },
    index_page_selected: 0,
    urlPortada:
      "https://t3.ftcdn.net/jpg/05/85/86/44/360_F_585864419_kgIYUcDQ0yiLOCo1aRjeu7kRxndcoitz.jpg",
    
    // Constantes
    defaultAvatar: 'https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small_2x/default-avatar-icon-of-social-media-user-vector.jpg',

    // Entorno
    node_env: process.env.NODE_ENV,
  },
  mutations: {
    // Estados de interfaz
    switchMeetingLeftSideBar(state) {
      state.showMeetingLeftSideBar = !state.showMeetingLeftSideBar;
    },
    switchNewMeetingWindow(state) {
      state.showNewMeetingWindow = !state.showNewMeetingWindow;
    },
    switchRightSideBar(state) {
      state.showRightSideBar = !state.showRightSideBar;
    },
    switchAddUserWindow(state) {
      state.showAddUserWindow = !state.showAddUserWindow;
    },
    switchUserProfile(state) {
      state.showUserProfile = !state.showUserProfile;
    },
    switchKanban(state) {
      state.showKanban = !state.showKanban;
    },
    switchBurndownChart(state) {
      state.showBurndownChart = !state.showBurndownChart;
    },
    switchTrelloCard(state) {
      state.showTrelloCard = !state.showTrelloCard;
    },
    setMessages(state, messages) {
      state.messages = messages;
    },
    pushMessage(state, message) {
      state.messages.push(message);
    },
    addNewMessageCount(state) {
      state.messagesWithoutRead++;
    },
    resetMessageCount(state) {
      state.messagesWithoutRead = 0;
    },
    setSnackbar(state, { value, text, color, icon }) {
      // console.log('set snackbar............', value, text, color, icon);
      state.snackbar = value ?? true;
      state.snackbarText = text;
      state.snackbarColor = color;
      state.snackbarIcon = icon;

      // console.log([state.snackbar, state.snackbarText, state.snackbarColor, state.snackbarIcon]);
    },
    restoreSnackbar(state) {
      state.snackbar = false;
      state.snackbarText = "";
      state.snackbarColor = "";
      state.snackbarIcon = "";
    },
    // Modelo de datos
    setProject(state, project) {
      state.project = project;
    },
    setProjectLists(state, projectsList) {
      state.projectsList = projectsList;
    },
    set(state, { att, value }) {
      try{
        state[att] = value;
      } catch(error) {
        console.error(error);
      }
    },
    setMeetingMinute(state, meetingMinute) {
      state.meetingMinute = meetingMinute;
    },
    updateMeetingMinute(state, meetingMinute) {
      state.meetingMinute = { ...state.meetingMinute, ...meetingMinute };
    },
    setMeeting(state, meeting) {
      state.meeting = meeting;
    },
    setElements(state, elements) {
      state.elements = elements;
    },
    setSelectedCard(state, card) {
      state.selectedCard = card;
    },
    updateProductBacklog(state, productBacklog) {
      const index = state.productBacklog.findIndex(item => item._id === productBacklog._id);
      if (index !== -1) {
      state.productBacklog[index] = productBacklog;
      }
    },
    updateSprintBacklog(state, sprintBacklog) {
      const index = state.sprintBacklog.findIndex(item => item._id === sprintBacklog._id);
      if (index !== -1) {
      state.sprintBacklog[index] = sprintBacklog;
      }
    },
    setProductBacklog(state, productBacklog) {
      state.productBacklog = productBacklog;
    },
    setSprintBacklog(state, sprintBacklog) {
      state.sprintBacklog = sprintBacklog;
    },
    setUser(state, user) {
      state.user = user;
    },
    updateMeeting(state, meeting) {
      state.meeting = { ...state.meeting, ...meeting };
    },
    // CMS al crear un nuevo proyecto
    updatePageContent(state, { index, content }) {
      state.newProject.pages[index].content = content;
    },
    setIndexPageSelected(state, index) {
      state.index_page_selected = index;
    },
    addNewPage(state, page) {
      state.newProject.pages.push(page);
    },
    // Mantiene propiedades antiguas de state.newProject
    // pero actualiza las nuevas propiedades que se encuentran en newProject
    updateNewProject(state, newProjectUpdated) {
      state.newProject = { ...state.newProject, ...newProjectUpdated };
    },
    
    /**
     * Updates the options for the new project in the state by merging the existing options
     * with the provided options.
     *
     * @param {Object} state - The Vuex state object. (automatically passed by Vuex)
     * @param {Object} options - The new options to merge into the existing new project options.
     */
    updateOptionsNewProject(state, options){
      state.newProject.options = { ...state.newProject.options, ...options};
    },
    deletePage(state, index) {
      state.newProject.pages = state.newProject.pages.filter((page) => page.index !== index);
    },
    // Agrega en mutations:
    setLocalStream(state, stream) {
      state.localStream = stream;
    },
    setMuted(state, muted) {
      state.isMuted = muted;
    },
  },
  getters: {
    getProject: (state) => state.project,
    getMeetingMinute: (state) => state.meetingMinute,
    getMeeting: (state) => state.meeting,
    getElements: (state) => state.elements,
  },
});
